<ng-template #template>
    <span class="c-text-with-tooltip">
      <span class="c-text-with-tooltip__text" [innerHTML]="tooltipText"></span>
      <ng-container *ngIf="displayHelperIcon">
        <span class="c-text-with-tooltip__tooltip js-tooltip">
          <button
            id="{{ ID_PREFIX }}{{ id }}"
            class="c-text-with-tooltip__btn js-tooltip-btn"
            [aswTooltip]="tooltipContent"
            [tooltipTop]="tooltipTop"
            [tooltipDisplayType]="tooltipDisplayType"
          >
            <span class="u-visually-hidden">Hint</span>
          </button>
        </span>
      </ng-container>
    </span>
  </ng-template>